import type { FormActionData } from '@axinom/mosaic-ui';
import { config } from 'config';
import {
  DomainEnvironmentMappingDataDocument,
  type DomainEnvironmentMappingDataQuery,
} from 'generated/portal-service';
import { environmentApolloClient } from 'modules/environmentApolloClient';

import { useEffect, useState } from 'react';

// export const createConfigurationMovedMessage = (
//   managementSystemUrl: string | undefined,
//   urlSuffix = '',
// ): StationMessage => {
//   return {
//     type: 'info',
//     title: (
//       <>
//         The service configuration has been moved to the{' '}
//         {managementSystemUrl ? (
//           <a
//             href={`${managementSystemUrl}${urlSuffix}`}
//             target="_blank"
//             rel="noreferrer"
//           >
//             management system
//           </a>
//         ) : (
//           'management system'
//         )}
//         .
//       </>
//     ),
//   };
// };

export const openConfigurationAction = (
  managementSystemUrl: string | undefined,
  urlSuffix = '',
): FormActionData => {
  if (!managementSystemUrl) {
    return {
      label: 'Service Settings',
      openInNewTab: true,
      path: '',
      isDisabled: true,
    };
  }
  return {
    label: 'Service Settings',
    openInNewTab: true,
    path: { pathname: `${managementSystemUrl}${urlSuffix}` },
  };
};

export const useManagementSystemUrl = (envId: string): string | undefined => {
  const [managementSystemUrl, setManagementSystemUrl] = useState<
    string | undefined
  >();

  useEffect(() => {
    (async () => {
      try {
        const envApolloClient = environmentApolloClient(
          envId,
          new URL(`/graphql`, config.portalServiceAdminBaseUrl).toString(),
        );

        const domainEnvironmentMappingDataResult =
          await envApolloClient?.query<DomainEnvironmentMappingDataQuery>({
            query: DomainEnvironmentMappingDataDocument,
            variables: {},
            fetchPolicy: 'no-cache',
          });
        if (
          domainEnvironmentMappingDataResult?.data?.domainEnvironmentMappings
            ?.nodes.length === 1
        ) {
          setManagementSystemUrl(
            `${domainEnvironmentMappingDataResult.data.domainEnvironmentMappings?.nodes[0].portalUrl}`,
          );
        }
      } catch (_e) {
        // Ignore errors when fetching the management system URL
      }
    })();
  }, [envId]);

  return managementSystemUrl;
};
